<template>
  <div class="c-table">
    <table class="rwd-table w-full mb-2 text-sm">
      <tbody>
        <tr>
          <th v-for="column in columns" :key="column.name" class="whitespace-no-wrap text-center">{{ column.label }}</th>
          <slot name="actionsLabel"></slot>
        </tr>
        <tr v-for="(item, index) in itemsWithIndex" :key="index">
          <td :data-th="column.label" v-for="(column, indexColumn) in columns" :key="indexColumn" @click="openModal">
            <span class="lg:hidden">
              {{ item[column.name] }}
            </span>
            <div class="flex-col items-center justify-center hidden lg:flex">
              {{ item[column.name] }}
            </div>
          </td>
          <slot name="actionsBtn" :item="item"></slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'Table',
    components: {
    },
    props: {
      columns: {
        name: String,
        required: Boolean,
        label: String,
        sortable: Boolean
      },
      data: Array
    },
    data () {
      return {
      }
    },
    computed: {
      itemsWithIndex () {
        if (this.data) {
          return this.data.map(
            (items, index) => ({
              ...items,
              index: index + 1
            }))
        }
        return []
      }
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
.cursorPointer {
  cursor: pointer;
}
.rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: separate;
  border-spacing: 0 1rem;
  color: #333;
  // overflow: hidden;
  tr {
    text-align: center;
    &:first-child {
      border-top: none;
    }
    th {
      display: none;
    }
  }
  td {
    text-align: center;
    display: block;
    background: white;
    &:before {
      content: attr(data-th) ": ";
      font-weight: bold;
      width: 120px;
      display: inline-block;
      color: #000;
    }
  }
}

@media screen and (max-width: 1025px) {
  // .rwd-table { border-spacing: 0 0rem !important; }
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-table th,
  .rwd-table td {
    // text-align: left;
  }
  .rwd-table th,
  .rwd-table td {
    padding: .5em 1em;
  }

}
@media screen and (min-width: 1024px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell !important;
    padding: .25em .5em;
  }
  // .rwd-table th:first-child,
  // .rwd-table td:first-child {
  //   padding-left: 0;
  // }
  // .rwd-table th:last-child,
  // .rwd-table td:last-child {
  //   padding-right: 0;
  // }
  .rwd-table td {
    padding: .5em !important;
  }
}
</style>